import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

interface ModalStylePopoverProps {
  children: React.ReactNode;
  onAccept?: () => void;
  onDismiss: () => void;
  style?: React.CSSProperties;
}

const ModalStylePopover: React.FC<ModalStylePopoverProps> = ({
  children,
  onAccept,
  onDismiss,
  style,
}) => {
  const popoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // const handleClickOutside = (e: MouseEvent) => {
    //   if (
    //     popoverRef.current &&
    //     !popoverRef.current.contains(e.target as Node)
    //   ) {
    //     onDismiss();
    //   }
    // };

    // const handleKeyDown = (e: KeyboardEvent) => {
    //   if (e.key === "Escape") onDismiss();
    // };

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden"; // ✅ lock body scroll

    // document.addEventListener("mousedown", handleClickOutside);
    // document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow; // ✅ restore on close
      // document.removeEventListener("mousedown", handleClickOutside);
      // document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onDismiss]);

  return ReactDOM.createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
      }}
    >
      <div
        ref={popoverRef}
        onWheel={(e) => e.stopPropagation()} // ✅ prevent scroll-through
        onTouchMove={(e) => e.stopPropagation()} // ✅ for touch devices
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "24px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          minWidth: "300px",
          maxWidth: "90vw",
          maxHeight: "90vh",
          overflowY: "auto",
          ...style,
        }}
      >
        {children}
        {onAccept && (
          <div style={{ marginTop: "1rem", textAlign: "right" }}>
            <button onClick={onAccept}>OK</button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ModalStylePopover;
